import ApiGraphQL from './client'
import unwrapGraphQL from './unwrap'


// Every scalar `MeetingAdvanced` carries, plus its attendees -- the keys match
// the full-object field names, so `new Meeting(json)` accepts the row as-is
// (`users` is what it builds `MeetingUsers` from).
//
// `notes` is deliberately NOT selected: it is a per-row nested list, and a
// picker shows a name, a project and a date.
const MEETING_FIELDS = `
    id companyId name projectId startMoment endMoment
    momentCreated createdByUserId isDeleted recurrencyId params
    users { userId role }
`

const MEETINGS_UDS = `query ($input: MeetingsUdsQueryInput!) {
    meetingsUds(input: $input) { ${MEETING_FIELDS} }
}`


export type MeetingsUdsInput = {
    startDate   : string    // YYYY-MM-DD, required by the backend
    endDate     : string    // YYYY-MM-DD, required by the backend
    userIds?    : ID[]
}

// One row as it comes back. Dates are raw strings -- the caller parses.
export type MeetingAdvancedJson = {
    id              : ID
    name            : string
    projectId       : ID
    isDeleted       : boolean
    startMoment     : string | null
    endMoment       : string | null
    momentCreated   : string | null

    [key: string]   : any
}


export default class ApiMeetingGql {

    // The date window is REQUIRED -- meetings are only ever fetched for a span,
    // never "all of them". `userIds` is optional; omitting it returns every
    // meeting in the window the viewer can see. There is no name filter on the
    // input -- callers that search do it client-side.
    static meetingsUds(input: MeetingsUdsInput) {
        return unwrapGraphQL<MeetingAdvancedJson[]>(
            ApiGraphQL.execute(MEETINGS_UDS, {input}),
            'meetingsUds'
        )
    }
}
